export default __webpack_public_path__ + "static/media/chat.804e6547.png";